import { Decimal } from '@mlm/shared';

/**
 * Wallet top-up at the till (cashier phase 5): the page's money rules, kept out
 * of the component so they are tested and so lint-staged can commit the page.
 */

/** Round loads a customer usually asks for, as one-tap buttons. */
export const TOPUP_PRESETS = [100, 200, 500, 1000, 2000, 5000] as const;

const AMOUNT_RE = /^\d+(\.\d{1,2})?$/;

/** A typed amount the server will take: positive, at most two decimals. */
export function isTopupAmount(value: string): boolean {
  const v = value.trim();
  return AMOUNT_RE.test(v) && new Decimal(v).gt(0);
}

/**
 * What a cash top-up hands back. `received` blank = the cashier did not type
 * it (null, nothing to show); too little = `short` by how much.
 */
export function topupChange(
  amount: string,
  received: string,
): { change: string } | { short: string } | null {
  const r = received.trim();
  if (!isTopupAmount(amount) || !AMOUNT_RE.test(r)) return null;
  const diff = new Decimal(r).minus(amount.trim());
  return diff.gte(0) ? { change: diff.toFixed(2) } : { short: diff.neg().toFixed(2) };
}

/** A fresh key per attempt, so a double tap or a retried request loads once. */
export function newTopupKey(): string {
  return `topup-${crypto.randomUUID()}`;
}
